















































import { computed, defineComponent, PropType } from "@vue/composition-api";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import { useToggle } from "@/helpers/hooks/useToggle";

export default defineComponent({
  name: "MessageBar",
  components: {
    Heading
  },
  props: {
    message: {
      type: String,
      required: false
    },
    messages: {
      type: Array as PropType<string[]>,
      required: false
    },
    scroll: {
      type: Boolean,
      default: false
    },
    collapse: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: String,
      default: ""
    },
    minHeight: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const [collapseOpen, toggleCollapseOpen] = useToggle(true);

    const messageBarStyle = computed(() => {
      if (!props.collapse) return {};

      return {
        "max-height": collapseOpen.value ? props.maxHeight : props.minHeight
      };
    });
    return {
      collapseOpen,
      toggleCollapseOpen,
      messageBarStyle
    };
  }
});
